if (!customElements.get("video-section")) {
  class VideoSection extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null, // Use the viewport as the root
        threshold: 0.9, // Trigger when 50% of the element is visible
      });
    }

    connectedCallback() {
      this.intersectionObserver.observe(this);
    }

    // Handle the intersection changes (when videos become visible/invisible)
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.querySelector(".video-section").classList.add("video-section--visible");
        }
      });
    }

    // Clean up the Intersection Observer when the element is removed from the DOM
    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  }

  customElements.define("video-section", VideoSection);
}
